export const historyQuizData = {
  "medieval": [
    {
      "question": "중세 음악의 시기는 대략 언제부터 언제까지인가요?",
      "options": ["200 — 900년", "500 — 1450년", "1000 — 1500년", "1400 — 1600년"],
      "answer": 1,
      "explanation": "중세 음악은 대략 500년부터 1450년까지 약 1000년에 걸친 시기입니다."
    },
    {
      "question": "중세 음악의 기반이 된 가톨릭 교회의 단선율 성가를 무엇이라고 하나요?",
      "options": ["마드리갈", "그레고리오 성가", "모테트", "코랄"],
      "answer": 1,
      "explanation": "그레고리오 성가는 중세 가톨릭 교회의 단선율 성가로 중세 음악의 기반입니다."
    },
    {
      "question": "중세 초기 다성음악의 초기 형태로, 단선율 위에 성부를 추가하는 음악 양식은 무엇인가요?",
      "options": ["오르가눔", "푸가", "대위법", "토카타"],
      "answer": 0,
      "explanation": "오르가눔은 중세 초기 다성음악의 형태로, 그레고리오 성가 위에 새로운 성부를 추가하는 방식입니다."
    },
    {
      "question": "12~13세기 파리 노트르담 대성당을 중심으로 발달한 중세 음악 학파는 무엇인가요?",
      "options": ["만하임 악파", "노트르담 악파", "피렌체 카메라타", "제2 빈악파"],
      "answer": 1,
      "explanation": "노트르담 악파는 파리 노트르담 대성당을 중심으로 발달한 다성음악 학파입니다."
    },
    {
      "question": "14세기 프랑스에서 일어난 음악 혁신 운동으로, 새로운 리듬 체계와 표기법을 도입한 사조는 무엇인가요?",
      "options": ["아르스 안티콰", "아르스 노바", "갈랑 양식", "인상주의"],
      "answer": 1,
      "explanation": "아르스 노바(Ars Nova)는 14세기 프랑스의 음악 혁신 운동으로 새로운 리듬 표기법을 도입했습니다."
    }
  ],
  "renaissance": [
    {
      "question": "르네상스 음악의 시기는 대략 언제부터 언제까지인가요?",
      "options": ["1200 — 1400년", "1420 — 1600년", "1600 — 1750년", "1750 — 1820년"],
      "answer": 1,
      "explanation": "르네상스 음악은 약 1420년부터 1600년 사이의 시기입니다."
    },
    {
      "question": "르네상스 시대에 음악의 보급에 크게 기여한 기술적 발명은 무엇인가요?",
      "options": ["전자 악기 발명", "악보 인쇄술 발명", "음반 녹음 기술", "피아노 발명"],
      "answer": 1,
      "explanation": "악보 인쇄술의 발명으로 음악이 더 널리 보급될 수 있었습니다."
    },
    {
      "question": "'팔레스트리나 양식'이라고도 불리는 르네상스 후기의 완성된 다성음악 기법은 무엇인가요?",
      "options": ["모노디 양식", "통모방 폴리포니", "감정과다 양식", "12음 기법"],
      "answer": 1,
      "explanation": "통모방 폴리포니는 팔레스트리나 양식으로도 불리는 르네상스 다성음악의 완성 형태입니다."
    },
    {
      "question": "르네상스 시대에 발달한 이탈리아 세속 성악 장르로, 시에 음악을 붙인 다성 성악곡은 무엇인가요?",
      "options": ["오라토리오", "마드리갈", "모테트", "칸타타"],
      "answer": 1,
      "explanation": "마드리갈은 르네상스 시대 이탈리아의 세속 다성 성악 장르입니다."
    },
    {
      "question": "르네상스 시대에 종교개혁과 함께 발달하여 회중이 함께 부르는 찬송가 형식은 무엇인가요?",
      "options": ["그레고리오 성가", "오르가눔", "프로테스탄트 코랄", "레퀴엠"],
      "answer": 2,
      "explanation": "프로테스탄트 코랄은 종교개혁과 함께 발달한 회중 찬송가 형식입니다."
    }
  ],
  "baroque": [
    {
      "question": "바로크 음악 시대는 언제부터 언제까지인가요?",
      "options": ["1420 — 1600년", "1600 — 1750년", "1750 — 1820년", "1820 — 1900년"],
      "answer": 1,
      "explanation": "바로크 음악은 1600년부터 1750년까지의 시기입니다."
    },
    {
      "question": "바로크 음악의 핵심 요소로, 즉흥 연주와 화성 채우기를 담당하는 저음부 반주 양식은 무엇인가요?",
      "options": ["오스티나토", "통주저음(바소 콘티누오)", "피치카토", "아르페지오"],
      "answer": 1,
      "explanation": "통주저음(Basso Continuo)은 바로크 음악의 핵심 요소로 즉흥적 화성 반주 양식입니다."
    },
    {
      "question": "바로크 시대에 탄생한 성악 중심의 극적 음악 장르는 무엇인가요?",
      "options": ["교향곡", "오페라", "소나타", "전주곡"],
      "answer": 1,
      "explanation": "오페라는 바로크 시대인 17세기 초 이탈리아에서 탄생했습니다."
    },
    {
      "question": "바로크 시대를 대표하는 작곡가로, 1750년 그의 사망으로 바로크 시대가 끝났다고 보는 인물은 누구인가요?",
      "options": ["게오르크 프리드리히 헨델", "안토니오 비발디", "요한 제바스티안 바흐", "클라우디오 몬테베르디"],
      "answer": 2,
      "explanation": "1750년 요한 제바스티안 바흐의 사망으로 바로크 시대가 끝났다고 간주합니다."
    },
    {
      "question": "독주 악기와 오케스트라가 대비되는 바로크 시대의 대표적 기악 형식은 무엇인가요?",
      "options": ["소나타", "협주곡", "교향곡", "환상곡"],
      "answer": 1,
      "explanation": "협주곡은 독주 악기와 오케스트라가 대비되는 바로크 대표 기악 형식입니다."
    }
  ],
  "classical": [
    {
      "question": "고전주의 음악의 시기는 언제부터 언제까지인가요?",
      "options": ["1600 — 1750년", "1680 — 1800년", "1750 — 1820년", "1820 — 1900년"],
      "answer": 2,
      "explanation": "고전주의 음악은 약 1750년부터 1820년 사이의 시기입니다."
    },
    {
      "question": "고전주의 시대에 확립된 음악 형식으로, 제시부·발전부·재현부로 구성된 형식은 무엇인가요?",
      "options": ["론도 형식", "통작 형식", "소나타 형식", "변주곡 형식"],
      "answer": 2,
      "explanation": "소나타 형식은 제시부, 발전부, 재현부로 구성되며 고전주의 시대에 확립된 대표적 음악 형식입니다."
    },
    {
      "question": "고전주의 시대의 중심 도시로, 하이든·모차르트·베토벤이 활동했던 도시는 어디인가요?",
      "options": ["파리", "런던", "베를린", "빈(비엔나)"],
      "answer": 3,
      "explanation": "빈(비엔나)은 고전주의 시대의 중심 도시로, 하이든·모차르트·베토벤이 활동했습니다."
    },
    {
      "question": "'교향곡의 아버지'와 '현악 사중주의 아버지'라는 두 가지 별명을 가진 고전주의 작곡가는 누구인가요?",
      "options": ["볼프강 아마데우스 모차르트", "루트비히 판 베토벤", "요제프 하이든", "무치오 클레멘티"],
      "answer": 2,
      "explanation": "요제프 하이든은 '교향곡의 아버지'와 '현악 사중주의 아버지'로 불립니다."
    },
    {
      "question": "고전주의 음악의 핵심적인 미적 가치로 가장 적절한 것은 무엇인가요?",
      "options": ["감정의 극적 해방과 민족주의", "균형과 형식적 명료함", "불협화음과 무조성", "감정 과다와 즉흥성"],
      "answer": 1,
      "explanation": "고전주의 음악의 핵심 가치는 균형과 형식적 명료함입니다."
    }
  ],
  "romantic": [
    {
      "question": "낭만주의 음악의 시기는 언제부터 언제까지인가요?",
      "options": ["1750 — 1820년", "1800 — 1870년", "1820 — 1900년", "1880 — 1950년"],
      "answer": 2,
      "explanation": "낭만주의 음악은 약 1820년부터 1900년 사이의 시기입니다."
    },
    {
      "question": "낭만주의 시대에 전성기를 맞이한 악기로, '낭만주의의 악기'라 불리는 것은 무엇인가요?",
      "options": ["바이올린", "하프시코드", "피아노", "오르간"],
      "answer": 2,
      "explanation": "피아노는 낭만주의 시대에 전성기를 맞이하며 다양한 감정 표현이 가능한 악기로 각광받았습니다."
    },
    {
      "question": "낭만주의 시대에 발달한 음악 양식으로, 문학·회화 등 다른 예술과 음악을 결합한 것은 무엇인가요?",
      "options": ["절대음악", "표제음악", "무조음악", "전자음악"],
      "answer": 1,
      "explanation": "표제음악은 문학이나 회화 등 다른 예술과 결합하여 이야기나 장면을 표현하는 낭만주의 대표 양식입니다."
    },
    {
      "question": "낭만주의 시대에 민족의 설화·민요 등을 음악에 담아 민족 정체성을 표현하는 경향을 무엇이라 하나요?",
      "options": ["신고전주의", "인상주의", "민족주의 음악", "표현주의"],
      "answer": 2,
      "explanation": "민족주의 음악은 각 나라의 민요와 민족적 요소를 담아 낭만주의 시대에 크게 발달했습니다."
    },
    {
      "question": "고전주의에서 낭만주의로 가는 다리 역할을 하며 '악성(樂聖)'이라 불리는 작곡가는 누구인가요?",
      "options": ["프란츠 슈베르트", "루트비히 판 베토벤", "프레데리크 쇼팽", "요하네스 브람스"],
      "answer": 1,
      "explanation": "루트비히 판 베토벤은 고전주의에서 낭만주의로의 다리 역할을 하며 '악성'으로 불립니다."
    }
  ],
  "modern": [
    {
      "question": "현대 음악의 시기는 일반적으로 언제부터로 보나요?",
      "options": ["1880년대부터", "1900년대부터", "1920년대부터", "1950년대부터"],
      "answer": 1,
      "explanation": "현대 음악은 일반적으로 1900년대 이후부터로 봅니다."
    },
    {
      "question": "20세기 초 프랑스에서 발달한 음악 사조로, 명확한 윤곽보다 색채와 분위기를 추구하는 것은 무엇인가요?",
      "options": ["표현주의", "인상주의", "신고전주의", "미니멀리즘"],
      "answer": 1,
      "explanation": "인상주의는 클로드 드뷔시 등이 대표하며 색채와 분위기를 중시하는 음악 사조입니다."
    },
    {
      "question": "아르놀트 쇤베르크가 창안한 작곡 기법으로, 12개의 반음을 동등하게 사용하는 기법은 무엇인가요?",
      "options": ["인상주의 기법", "12음 기법(도데카포니)", "미니멀리즘", "총렬주의"],
      "answer": 1,
      "explanation": "12음 기법(도데카포니)은 쇤베르크가 창안한 기법으로 12개 반음을 동등하게 사용합니다."
    },
    {
      "question": "20세기에 등장한 새로운 음악 형태로, 전자 기기와 컴퓨터를 활용하는 음악 장르는 무엇인가요?",
      "options": ["실내악", "전자음악", "오라토리오", "가곡"],
      "answer": 1,
      "explanation": "전자음악은 전자 기기와 컴퓨터를 활용하는 현대 음악의 새로운 형태입니다."
    },
    {
      "question": "필립 글라스, 스티브 라이히 등이 대표하는 현대 음악 사조로, 단순한 음형을 반복하는 것이 특징인 것은 무엇인가요?",
      "options": ["표현주의", "신원시주의", "미니멀리즘", "우연성 음악"],
      "answer": 2,
      "explanation": "미니멀리즘은 단순한 음형의 반복을 특징으로 하며, 필립 글라스·스티브 라이히 등이 대표합니다."
    }
  ]
};
